import {StateUpdateChatEventNode, ClientChatEvent} from './messages/MessageTypes';

interface ChatSystemState {
  error_message?: string;
}

function getLatestStateUpdateEvent(events: Array<ClientChatEvent>): StateUpdateChatEventNode | undefined {
  return events.findLast<StateUpdateChatEventNode>(
    (event) => event.__typename === 'StateUpdateChatEventNode'
  );
}

export function getLatestApplicationState(events: Array<ClientChatEvent>): object | null {
  const stateUpdateEvent = getLatestStateUpdateEvent(events);
  return stateUpdateEvent?.newState.chat_state.application_state ?? null;
}

export function getLatestSystemState(events: Array<ClientChatEvent>): ChatSystemState | null {
  const stateUpdateEvent = getLatestStateUpdateEvent(events);
  return stateUpdateEvent?.newState.chat_state.system_state ?? null;
}
